import React, { useContext, useState,useEffect } from 'react';
import { CartContext } from './contexts/CartContext';
import { Link, useParams } from 'react-router-dom';
import PageTitle from './includes/PageTitle';
import shirt1 from './images/shirt1.jpg'; // Correctly import the image
import shirt2 from './images/shirt2.jpg'; // Correctly import the image
import './css/Cart.css';
import { Modal, Box, Button, Typography } from '@mui/material';


function Cart() {
    const { cart, removeFromCart, updateQuantity, clearAll, cartSummary } = useContext(CartContext);

    const handleQuantityChange = (id, color, size, newQuantity) => {
      if (newQuantity >= 1 && newQuantity <= 20) {
        updateQuantity(id, color, size, newQuantity);
      }
    };
  return (
    <>
        <PageTitle title="Shopping Bag - ALMOSTINVISIBLE" />
        {cart.length === 0 ? (
            // Render cart content when there are items in the cart
            <>
            
            <div className="d-flex align-content-center flex-column container justify-content-start" style={{margin: "30vh auto"}}>
                    <div>
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="7em" width="7em" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2c5.523 0 10 4.477 10 10a9.958 9.958 0 0 1-1.065 4.496 1.977 1.977 0 0 0-.398-.775l-.123-.135L19 14.172l-1.414 1.414-.117.127a2 2 0 0 0 1.679 3.282A9.974 9.974 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2zm0 13c-1.38 0-2.63.56-3.534 1.463l-.166.174.945.86C10.035 17.182 10.982 17 12 17c.905 0 1.754.144 2.486.396l.269.1.945-.86A4.987 4.987 0 0 0 12 15zm-3.5-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"></path></g></svg>                    
                    </div>
                    <div className="d-flex flex-column">
                        <h1 className="unbounded" style={{fontSize: "40px"}}>
                            Your Shopping Bag Is Currently Empty
                        </h1>
                        <div className="d-flex align-content-center ">
                            <p className='nunito-2 fw-bold h4 mt-2'>
                                Fill it up now
                            </p>
                            <Link to='/products' className='black-button mx-4'>
                                Shop Now
                            </Link>
                        </div>
                        
                    </div>
                    
                </div>
            {/* Render cart items, summary, and checkout form here */}
            </>
        ) : (
            <div className="cart-container">
                <div class="container px-4">
                    <div class="row gx-5">
                        <div className="col-md-8">
                            <h1 className='unbounded text-center'>Shopping Bag</h1>
                            <div className="cart-header">
                                <Link to="/products" className="continue-shopping fw-bold nunito-2 border-bottom-hover">
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.3em" width="1.3em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z" clip-rule="evenodd"></path></svg>
                                    Continue Shopping
                                </Link>
                                
                                <span className='nunito'>{cartSummary.totalItems} item(s)</span>
                            </div>
                            <ul className="cart-items">
                                {cart.map((item) => (
                                <li key={`${item.id}-${item.color}-${item.size}`} className="cart-item">
                                    <img src={item.images[0]} alt={item.name} className="cart-item-image" />
                                    <div className="cart-item-details">
                                        <p className='nunito-sans fw-bold'>{item.name}</p>
                                        <p>Color: {item.color}</p>
                                        <p>Size: {item.size}</p>
                                        <div className="cart-item-quantity">
                                            <button className="qty-btn" onClick={() => handleQuantityChange(item.id, item.color, item.size, item.quantity - 1)}>
                                                <svg viewBox="0 0 409.6 409.6">
                                                    <g>
                                                        <g>
                                                            <path d="M392.533,187.733H17.067C7.641,187.733,0,195.374,0,204.8s7.641,17.067,17.067,17.067h375.467 c9.426,0,17.067-7.641,17.067-17.067S401.959,187.733,392.533,187.733z" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </button>
                                            <input
                                                type="number"
                                                min="1"
                                                max="20"
                                                value={item.quantity}
                                                onChange={(e) => handleQuantityChange(item.id, item.color, item.size, parseInt(e.target.value))}
                                            />
                                            <button className="qty-btn" onClick={() => handleQuantityChange(item.id, item.color, item.size, item.quantity + 1)}>
                                                <svg viewBox="0 0 426.66667 426.66667">
                                                    <path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="cart-item-price">
                                        <button onClick={() => removeFromCart(item.id, item.color, item.size)} className="remove-item">×</button>
                                        <p>₦{(item.price * item.quantity).toFixed(2)}</p>
                                    </div>
                                </li>
                                ))}
                            </ul>
                        </div>

                    
                        <div className="cart-summary col-md-4">
                            <h1 className="unbounded">
                                Summary
                            </h1>
                            
                            <div className="cart-totals nunito-2">
                                <div className="cart-totals-row">
                                    <span className='nunito-sans'>Subtotal</span>
                                    <span className='nunito-sans'>₦{cartSummary.subTotal.toFixed(2)}</span>
                                </div>
                                <div className="cart-totals-row">
                                    <span>Shipping</span>
                                    <span>Calculated at checkout</span>
                                </div>
                                <hr />
                                <div className="cart-totals-row total">
                                    <span>Total</span>
                                    <span>₦{cartSummary.subTotal.toFixed(2)}</span>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <Link className="black-button" to="/checkout">
                                    Check Out
                                </Link>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        )}              
        {/** 
         * FEATURE TO BE ADDED LATER. WHEN THE CHECKOUT BUTTON I[S CLICKED ON IT OPNES THIS MODAL
         * AND THEN SHOWS TWO SUGGESTED PRODUCT THE CUSTOMER CAN ADD TO CART 
         * THEN THEY CAN GO TO THE CHECKOUT PAGE BY CLICKING THE CONTINUE BUTTON "<button className="black-button" data-bs-toggle="modal" data-bs-target="#suggestionModal">
                            Check Out
                        </button>"
        <div class="modal" id="suggestionModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">

                    <div class="modal-header">
                        <h4 class="modal-title nunito-2 .black-bordered-bottom">You might also like</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body">
                        <ul className="cart-items">
                        {productList.map((product) => (
                            <li key={product.id} className="cart-item">
                                <img src={product.imageUrl} alt={product.name} className="cart-item-image" />
                                <div className="cart-item-details">
                                    <p className='nunito-sans fw-bold'>{product.name}</p>
                                    <p>Color: Black</p>
                                    <p>Size: M</p>
                                    <p>₦{product.price}</p>
                                    <div className="cart-item-quantity">
                                        <button className="qty-btn" onClick={() => handleQuantityChange(product.id, product.color, product.size, product.quantity - 1)}>
                                            <svg viewBox="0 0 409.6 409.6">
                                                <g>
                                                    <g>
                                                        <path d="M392.533,187.733H17.067C7.641,187.733,0,195.374,0,204.8s7.641,17.067,17.067,17.067h375.467 c9.426,0,17.067-7.641,17.067-17.067S401.959,187.733,392.533,187.733z" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </button>
                                        <input
                                            type="number"
                                            min="1"
                                            max="20"
                                            value={product.quantity}
                                            onChange={(e) => handleQuantityChange(product.id, product.color, product.size, parseInt(e.target.value))}
                                        />
                                        <button className="qty-btn" onClick={() => handleQuantityChange(product.id, product.color, product.size, product.quantity + 1)}>
                                            <svg viewBox="0 0 426.66667 426.66667">
                                                <path d="m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0 11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031 21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594 21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0" />
                                            </svg>
                                        </button>
                                    </div>
                                    
                                    
                                </div>
                                <div className="cart-item-price">
                                    <Link to={`/product/${product.id}`} className='black-button' data-bs-dismiss="modal">
                                        View Product
                                    </Link>
                                    <button className='black-button' onClick={handleAddToCart} >Add to Cart</button>
                                </div>
                            </li>
                        ))}
                           
                        </ul>
                    </div>

                    <div class="modal-footer">
                        <Link to="/checkout" class="black-button">
                            Continue To Checkout
                        </Link>
                    </div>

                </div>
            </div>
        </div>*/}
    </>
  );
}

export default Cart;
